import React, { useState, useEffect } from 'react';

const BootScreen = () => {
  const [loadingBoxes, setLoadingBoxes] = useState([]);
  const [currentBox, setCurrentBox] = useState(0);

  useEffect(() => {
    // Create 12 boxes
    const boxes = Array.from({ length: 12 }, (_, i) => ({
      id: i,
      filled: false
    }));
    setLoadingBoxes(boxes);

    // Animate boxes filling blue one by one
    const boxInterval = setInterval(() => {
      setCurrentBox(prev => {
        if (prev < 12) {
          setLoadingBoxes(prevBoxes => 
            prevBoxes.map((box, index) => 
              index === prev ? { ...box, filled: true } : box
            )
          );
          return prev + 1;
        } else {
          clearInterval(boxInterval);
          return prev;
        }
      });
    }, 150);

    return () => clearInterval(boxInterval);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: '#C0C0C0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      fontFamily: 'MS Sans Serif, sans-serif',
      color: 'black',
      overflow: 'hidden'
    }}>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '40px' }}>
        {loadingBoxes.map((box) => (
          <div
            key={box.id}
            style={{
              width: '20px',
              height: '12px',
              background: box.filled ? '#0000AA' : '#A0A0A0',
              border: '1px solid #404040'
            }}
          />
        ))}
      </div>
      <div style={{ fontSize: '14px' }}>Booting Avo's Portfolio...</div>
    </div>
  );
};

export default BootScreen;
